import '../../css/style.scss'
import {Sound} from '../../../shared/scripts/Sound'
import {UIMinimalHeaderController} from '../ui_html/new_layout/UIMinimalHeaderController'
import {UISidebarController} from '../ui_html/new_layout/UISidebarController'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared'
import {UIChampionship25Controller} from '../../../shared/scripts/ui_cc/UIChampionship25Controller'

void init()

async function init() {
    Sound.loadSounds()

    await EntryShared.initializeEntry()

    const headerController = new UIMinimalHeaderController()
    new UISidebarController()

    new UIChampionship25Controller()

    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    EntryShared.sendPageVisitAnalyticEvent()
}
